// extracted by mini-css-extract-plugin
module.exports = {"infoDiv":"EditLicense_infoDiv__2GW1N","title":"EditLicense_title__2yHrD"};